module.exports = "https://static.futunn.com/components/common-price-guess/images/icon-now.e266e6e932.png";